module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-layout"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    ref: "search",
    staticClass: "search-box no-border",
    class: {
      showing: _vm.searchVisible
    },
    attrs: {
      "type": "text",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "keydown": [_vm.debouncedRunSearch, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterRunSearch($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.cancelSearch($event)
      }],
      "blur": _vm.lostFocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "text": ""
    },
    on: {
      "click": _vm.toggleSearchVisibility
    }
  }, [(_vm.searchVisible) ? _c('v-icon', [_vm._v("close")]) : _c('v-icon', [_vm._v("search")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d145cf4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/ToolbarSearch.vue
// module id = 2494
// module chunks = 1